import * as types from './types';

const initialState = {
	list: [],
	current: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case types.GET_LIST:
			return {
				...state,
				list: action.payload
			};
		case types.SET_ONE:
			return {
				...state,
				current: action.payload
			};
		case types.DELETE_ONE:
			return {
				...state,
				current: {}
			};
		default:
			return state;
	}
}
